import { useState } from "react";
import { Music } from "lucide-react";
import { startAmbience, stopAmbience } from "@/lib/music";

export default function MusicToggle() {
  const [playing, setPlaying] = useState(false);

  const toggle = () => {
    if (playing) stopAmbience();
    else startAmbience();
    setPlaying((p) => !p);
  };

  return (
    <button
      className={`music-btn ${playing ? "playing" : ""}`}
      data-testid="music-toggle"
      aria-label={playing ? "Metti in pausa la musica" : "Attiva la musica"}
      onClick={toggle}
    >
      {playing ? (
        <span className="eq">
          <span />
          <span />
          <span />
        </span>
      ) : (
        <Music size={15} strokeWidth={1.8} />
      )}
    </button>
  );
}
